import React, {useState} from "react";
import {Accordion, AccordionSummary, AccordionDetails, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface EntraIdGraphicCardProps {
    employeeImage: string;
    marginTop: string;
    marginBottom: string;
}

const EntraIdGraphicCard: React.FC<EntraIdGraphicCardProps> = ({
                                                                   employeeImage,
                                                                   marginTop = "16px",
                                                                   marginBottom = "16px"
                                                               }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const openModal = () => {
        setIsOpen(true);
        // small timeout to trigger CSS transition
        setTimeout(() => setIsVisible(true), 10);
    };

    const closeModal = () => {
        setIsVisible(false);
        // wait for transition to finish before removing modal from DOM
        setTimeout(() => setIsOpen(false), 300);
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "5px",
            marginTop: marginTop,
            marginBottom: marginBottom
        }}>
            {/* Small employee image */}
            <Accordion sx={{width: "100%"}}>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography variant="body1" fontWeight={600}>
                        Entra ID integrasjonsguide
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <Typography variant="body1" paddingBottom={marginBottom}>
                        Vi bruker konkrete Properties for å hente informasjon om ansatte.
                        Vi har highlighet på bildet under hvilke properties dette er. Dersom både First name og Last
                        name er tomme vil vi prøve å fylle dem ut ved hjelp av Display name propertien.
                        <br/><br/>
                        <strong>Pålagte properties er:</strong>
                        <br/>• First name
                        <br/>• Last name
                        <br/>• Job title
                        <br/>• Department
                        <br/><br/>
                        <strong>Minst en av disse må være med:</strong>
                        <br/>• Mobile phone
                        <br/>• Email
                        <br/><br/>
                        <strong>Valgfrie:</strong>
                        <br/>• Employee ID
                    </Typography>

                    <img
                        src={employeeImage}
                        alt="Employee"
                        style={{
                            width: "128px",
                            height: "128px",
                            borderRadius: "10%",
                            cursor: "pointer",
                            objectFit: "cover",
                            border: "1px solid #ccc",
                        }}
                        onClick={openModal}
                    />

                    {/* Modal / enlarged image */}
                    {isOpen && (
                        <div
                            onClick={closeModal}
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(0,0,0,0.7)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999,
                                opacity: isVisible ? 1 : 0,
                                transition: "opacity 0.2s ease",
                            }}
                        >
                            <img
                                src={employeeImage}
                                alt="Employee Enlarged"
                                onClick={closeModal}
                                style={{
                                    maxWidth: "90%",
                                    maxHeight: "90%",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    transform: isVisible ? "scale(1)" : "scale(0.8)",
                                    transition: "transform 0.2s ease",
                                }}
                            />
                        </div>
                    )}

                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default EntraIdGraphicCard;
